import { Star } from 'lucide-react';

/** Read-only 1–5 star row. Gold matches the customer-facing star page. */
export function Stars({ n, className = 'h-3.5 w-3.5' }: { n: number; className?: string }) {
  return (
    <span className="inline-flex items-center gap-0.5" aria-label={`${n} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={className}
          strokeWidth={1.5}
          style={{
            color: i <= n ? '#f5b301' : 'hsl(var(--muted-foreground) / 0.4)',
            fill: i <= n ? '#f5b301' : 'transparent',
          }}
        />
      ))}
    </span>
  );
}
